export default {
  actions: {
    ERROR: 'ERROR',
  },
};
